export const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
    padding: 0,
    width: '100%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
  },
  group: {
    marginBottom: theme.spacing(2)
  },
  label: {
    fontWeight: 'bold',
    padding: 0,
    marginBottom: theme.spacing(2)

  },
  button: {
    float: 'right'
  }
})
  